const SHOW_USER_DELETED = 'nibi_admin/notifications/SHOW_USER_DELETED';
const HIDE_USER_DELETED = 'nibi_admin/notifications/HIDE_USER_DELETED';
const SHOW_ARTICLE_CREATED = 'nibi_admin/notifications/SHOW_ARTICLE_CREATED';
const HIDE_ARTICLE_CREATED = 'nibi_admin/notifications/HIDE_ARTICLE_CREATED';
const SHOW_ARTICLE_DELETED = 'nibi_admin/notifications/SHOW_ARTICLE_DELETED';
const HIDE_ARTICLE_DELETED = 'nibi_admin/notifications/HIDE_ARTICLE_DELETED';
const SHOW_FOUNDATION_DELETED = 'nibi_admin/notifications/SHOW_FOUNDATION_DELETED';
const HIDE_FOUNDATION_DELETED = 'nibi_admin/notifications/HIDE_FOUNDATION_DELETED';
const SHOW_ENTERPRISE_DELETED = 'nibi_admin/notifications/SHOW_ENTERPRISE_DELETED';
const HIDE_ENTERPRISE_DELETED = 'nibi_admin/notifications/HIDE_ENTERPRISE_DELETED';

const initialState = {
  showUserDeleted: false,
  showArticleCreated: false,
  showArticleDeleted: false,
  showFoundationDeleted: false,
  showEnterpriseDeleted: false
};

export default function reducer(state = initialState, action) {

  switch (action.type) {
    case SHOW_USER_DELETED:
      return {
        ...state,
        showUserDeleted: true
      };
    case HIDE_USER_DELETED:
      return {
        ...state,
        showUserDeleted: false
      };
    case SHOW_ARTICLE_CREATED:
      return {
        ...state,
        showArticleCreated: true
      };
    case HIDE_ARTICLE_CREATED:
      return {
        ...state,
        showArticleCreated: false
      };
    case SHOW_ARTICLE_DELETED:
      return {
        ...state,
        showArticleDeleted: true
      };
    case HIDE_ARTICLE_DELETED:
      return {
        ...state,
        showArticleDeleted: false
      };
    case SHOW_FOUNDATION_DELETED:
      return {
        ...state,
        showFoundationDeleted: true
      };
    case HIDE_FOUNDATION_DELETED:
      return {
        ...state,
        showFoundationDeleted: false
      };
    case SHOW_ENTERPRISE_DELETED:
      return {
        ...state,
        showEnterpriseDeleted: true
      };
    case HIDE_ENTERPRISE_DELETED:
      return {
        ...state,
        showEnterpriseDeleted: false
      };
    default:
      return state;
  }

}

export function showUserDeletedNotification() {
  return { type: SHOW_USER_DELETED };
}

export function hideUserDeletedNotification() {
  return { type: HIDE_USER_DELETED };
}

export function showArticleCreatedNotification() {
  return { type: SHOW_ARTICLE_CREATED };
}

export function hideArticleCreatedNotification() {
  return { type: HIDE_ARTICLE_CREATED };
}

export function showArticleDeletedNotification() {
  return { type: SHOW_ARTICLE_DELETED };
}

export function hideArticleDeletedNotification() {
  return { type: HIDE_ARTICLE_DELETED };
}

export function showFoundationDeletedNotification() {
  return { type: SHOW_FOUNDATION_DELETED };
}

export function hideFoundationDeletedNotification() {
  return { type: HIDE_FOUNDATION_DELETED };
}

export function showEnterpriseDeletedNotification() {
  return { type: SHOW_ENTERPRISE_DELETED };
}

export function hideEnterpriseDeletedNotification() {
  return { type: HIDE_ENTERPRISE_DELETED };
}
